import { genderOptions } from './selectButtonOptions';

export const getGenderName = (value: string | undefined): string => {
  if (value === 'they/them') {
    return 'Non-Binary';
  }
  const gender = genderOptions.find((option) => option.value === value);
  return gender?.label || (value as string);
};
